// So Lucky Health & Wellness — minimal theme JS
(function () {
  'use strict';

  // Update cart count after add-to-cart from product cards (uses Shopify AJAX API)
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
      })
      .catch(function () { /* ignore */ });
  }

  // Intercept product-card add-to-cart forms for ajax-style UX
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product-card__add-form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.disabled = true;

    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(function (r) { return r.json(); })
      .then(function () {
        updateCartCount();
        if (btn) { btn.disabled = false; }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        form.submit();
      });
  });

  // Initial cart count sync on page load (in case storefront sets it stale)
  document.addEventListener('DOMContentLoaded', updateCartCount);
})();
